"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82778],{

/***/ 69150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8522);
/** @format */ 




var AlgorithmTab = function(param) {
    var outputJson = param.outputJson;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), getUrl = ref[0], setGetUrl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), method = ref1[0], setMethod = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), score = ref2[0], setScore = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), feature = ref3[0], setFeature = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), using = ref4[0], setUsing = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), target = ref5[0], setTarget = ref5[1];
    // const [preprocessInfo, setPreprocessInfo] = useState();
    // const [suggestionSpeed, setSuggestionSpeed] = useState();
    // const [suggestionStart, setSuggestionStart] = useState();
    // const [suggestionEnd, setSuggestionEnd] = useState();
    /** 데이터 분석 목록 받아오기 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var storageFileRef;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            if (outputJson) {
                storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_2__/* .projectStorage.ref */ .v.ref(outputJson);
                storageFileRef.getDownloadURL().then(function(url) {
                    setGetUrl(url);
                }).catch(function(error) {
                    ;
                });
            }
            return [
                2
            ];
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var res, algorithmData, jsonResult, jsonTarget;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!getUrl) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetch(getUrl)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    algorithmData = _state.sent();
                    jsonResult = algorithmData.result;
                    jsonTarget = algorithmData.target;
                    setMethod(jsonResult.Method);
                    setScore(jsonResult.Score);
                    setFeature(jsonResult.feature_importance);
                    setUsing(jsonResult.using);
                    setTarget(jsonTarget);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        getUrl
    ]);
    // const handleFileDownload = () => {
    //   const fileNameSplit = outputJson.split("/");
    //   const lastFileName = fileNameSplit[fileNameSplit.length - 1];
    //   const fileName = lastFileName.split(".");
    //   const blob = new Object();
    //   blob.before = { shape: preprocessInfo.before.shape, count: preprocessInfo.before.count };
    //   blob.after = { shape: preprocessInfo.after.shape, count: preprocessInfo.after.count };
    //   blob.time = { start: preprocessInfo.start, end: preprocessInfo.end, time: preprocessInfo.time };
    //   blob.accuracy = preprocessInfo.accuracy;
    //   blob.suggestion = { speed: suggestionSpeed, start: suggestionStart, end: suggestionEnd };
    //   blob.score = score ? Number(score[Object.keys(score)]) * 100 : 0;
    //   var element = document.createElement("a");
    //   var newFile = new Blob([JSON.stringify(blob)], {
    //     type: "text/plain",
    //   });
    //   element.href = URL.createObjectURL(newFile);
    //   element.download = `preprocess_${fileName[0]}.txt`;
    //   document.body.appendChild(element);
    //   element.click();
    //   document.body.removeChild(element);
    // };
    if (!outputJson || !getUrl) return "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-table",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "px-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row flex items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-3 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 text-888 font-bold",
                                children: "학습유형"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-9 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row px-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "font-bold text-333 py-2 px-3 bg-gray-input rounded-md mb-2.5",
                                    children: method
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row flex items-srart mt-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-3 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 text-888 font-bold",
                                children: "사용된 알고리즘"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-9 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row px-3",
                                children: using ? using.map(function(m, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5",
                                        children: m
                                    }, "".concat(m).concat(index));
                                }) : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row flex items-start mt-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-3 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 text-888 font-bold",
                                children: "타켓"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-9 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row px-3",
                                children: target ? target.map(function(m) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5",
                                        children: m
                                    }, m);
                                }) : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row flex items-start mt-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-12 col-md-3 mt-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-0 text-888 font-bold",
                                    children: "학습에 영향을 준 특징들"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-0 text-888 font-bold text-xs mt-1",
                                    children: "( 중요한 특징 순서 )"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-9 mt-3",
                            children: feature ? feature.map(function(m, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row px-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 text-aaa font-bold mr-3 text-lg",
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mt-1 font-bold text-333 bg-gray-input rounded-md",
                                                children: m
                                            })
                                        ]
                                    })
                                }, m);
                            }) : ""
                        })
                    ]
                }),
                method === "regression" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row flex items-start mt-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-3 mt-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 text-888 font-bold",
                                children: "모델 평가"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-12 col-md-9 mt-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row px-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "font-bold text-lg text-primary py-1 rounded-md",
                                        children: [
                                            "R2 : ",
                                            score ? score.R2 : "0",
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row px-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "font-bold text-lg text-primary py-1 rounded-md",
                                        children: [
                                            "MSE : ",
                                            score ? score.MSE : "0",
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row px-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "font-bold text-lg text-primary py-1 rounded-md",
                                        children: [
                                            "RMSE : ",
                                            score ? score.RMSE : "0",
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row px-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "font-bold text-lg text-primary py-1 rounded-md",
                                        children: [
                                            "MAE : ",
                                            score ? score.MAE : "0",
                                            " "
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row flex items-center mt-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-3 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 text-888 font-bold",
                                children: "정확도"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-md-9 mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row px-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "font-bold text-lg text-primary py-1 rounded-md",
                                    children: [
                                        score ? Number(score[Object.keys(score)]) * 100 : "0",
                                        " %"
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AlgorithmTab);


/***/ }),

/***/ 82778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dataAnalysisTabs_DataAnalysisDetailTab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js
var Tab = __webpack_require__(56841);
;// CONCATENATED MODULE: ./components/dataAnalysisTabs/ColumnsInfoTab.js
/** @format */ 

var ColumnsInfoTab = function(param) {
    var csvInfo = param.csvInfo, target = param.target;
    var ref = (0,react.useState)([]), newCsvInfo = ref[0], setNewCsvInfo = ref[1];
    (0,react.useEffect)(function() {
        if (csvInfo) {
            var tempNewCsvInfo = [];
            for(var i in Object.keys(csvInfo)){
                tempNewCsvInfo.push({
                    key: Object.keys(csvInfo)[i],
                    value: Object.values(csvInfo)[i]
                });
            }
            setNewCsvInfo(tempNewCsvInfo);
        }
    }, [
        csvInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full bg-gray-input rounded-xl p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: "text-333 font-bold",
                    children: "컬럼 설명"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full flex items-center mt-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-333 font-bold mb-0 mr-6 w-4/12",
                            children: "컬럼명"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-333 font-bold mb-0 mr-6 w-2/12",
                            children: "데이터 타입"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-333 font-bold mb-0 mr-3 w-6/12",
                            children: "설명"
                        })
                    ]
                })
            }),
            newCsvInfo && newCsvInfo.map(function(m) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex items-center mt-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-333 font-bold mb-0 mr-3 w-4/12",
                                children: m.key
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-3 w-2/12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "bg-white rounded-full mb-0 py-1 px-3 mx-2 flex justify-center",
                                    children: m.value.dataType
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "px-3 py-1 mb-0 rounded-full mr-3 w-6/12",
                                children: m.value.info
                            })
                        ]
                    })
                }, m.key);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex items-center mt-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-primary font-bold mb-0 mr-6 w-4/12",
                                children: "타켓 컬럼(결과 컬럼)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white bg-primary font-bold mb-0 mr-6 w-4/12 flex justify-center py-1 px-2",
                                children: target
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var dataAnalysisTabs_ColumnsInfoTab = (ColumnsInfoTab);

// EXTERNAL MODULE: ./components/dataAnalysisTabs/DataAnalysisTab.js
var DataAnalysisTab = __webpack_require__(69495);
// EXTERNAL MODULE: ./components/dataAnalysisTabs/AlgorithmTab.js
var AlgorithmTab = __webpack_require__(69150);
;// CONCATENATED MODULE: ./components/dataAnalysisTabs/DataAnalysisDetailTab.js






// import DataAnalysisTestTab from "components/dataAnalysisTabs/DataAnalysisTestTab";
var DataAnalysisDetailTab = function(param) {
    var csvInfo = param.csvInfo, target = param.target, outputJson = param.outputJson, outputHtml = param.outputHtml, outputMatrix = param.outputMatrix;
    if (outputMatrix) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aiso-tab tab-3 border-none w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                    defaultActiveKey: "Tab1",
                    id: "uncontrolled-tab-example",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "Tab1",
                            title: "컬럼 설명",
                            className: "test-tab",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dataAnalysisTabs_ColumnsInfoTab, {
                                csvInfo: csvInfo,
                                target: target
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "Tab2",
                            title: "데이터 분석",
                            className: "test-tab",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DataAnalysisTab/* default */.Z, {
                                outputHtml: outputHtml
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "Tab3",
                            title: "알고리즘",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlgorithmTab/* default */.Z, {
                                outputJson: outputJson
                            })
                        })
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aiso-tab tab-3 border-none w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                    defaultActiveKey: "Tab1",
                    id: "uncontrolled-tab-example",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "Tab1",
                            title: "컬럼 설명",
                            className: "test-tab",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dataAnalysisTabs_ColumnsInfoTab, {
                                csvInfo: csvInfo,
                                target: target
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "Tab2",
                            title: "데이터 분석",
                            className: "test-tab",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DataAnalysisTab/* default */.Z, {
                                outputHtml: outputHtml
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "Tab3",
                            title: "알고리즘",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlgorithmTab/* default */.Z, {
                                outputJson: outputJson
                            })
                        })
                    ]
                })
            })
        });
    }
};
/* harmony default export */ var dataAnalysisTabs_DataAnalysisDetailTab = (DataAnalysisDetailTab);


/***/ }),

/***/ 69495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8522);
/** @format */ 




var DataAnalysisTab = function(param) {
    var outputHtml = param.outputHtml;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), htmlUrl = ref[0], setHtmlUrl = ref[1];
    /** 데이터 분석 목록 받아오기 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var storageFileRef;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            if (outputHtml) {
                storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_2__/* .projectStorage.ref */ .v.ref(outputHtml);
                storageFileRef.getDownloadURL().then(function(url) {
                    setHtmlUrl(url);
                }).catch(function(error) {
                    ;
                });
            }
            return [
                2
            ];
        });
    }), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-table",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "full mx-auto data-style",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-full",
                dangerouslySetInnerHTML: {
                    __html: '<iframe src="'.concat(htmlUrl, '"  width="100%"  style="height:700px" />')
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DataAnalysisTab);


/***/ })

}]);